<template>
    <b-card no-body>
        <b-card-header>
            <span class="h5">
                PRÉ-CONTRATO -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </span>
        </b-card-header>
        <b-card-body>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <div>
                <b-row>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="numeroContrato"
                                class="required"
                                >Código do contrato</label
                            >
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    id="numeroContrato"
                                    placeholder="Digite o número do contrato"
                                    v-model="preContratoDto.vcCodigoEstruturado"
                                    v-mask="'##.####'"
                                    max="11"
                                    :disabled="!habilitaCampos"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="tipoContratacao"
                                class="required"
                                >Tipo da contratação</label
                            >
                            <b-form-select
                                class="mb-2 mr-sm-2 mb-sm-0"
                                :plain="true"
                                :options="tiposContratacao"
                                v-model="preContratoDto.tpContratacao"
                                @change="selecionaTipoContratacao($event)"
                                :disabled="edicaoPreContrato || !habilitaCampos"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2" v-if="!isTermoCadastramento">
                        <b-form-group>
                            <label for="tipoLicitacao" class="required">
                                Tipo da Licitação
                            </label>
                            <b-form-select
                                class="mb-2 mr-sm-2 mb-sm-0"
                                :plain="true"
                                :options="tiposLicitacao"
                                v-model="preContratoDto.codTipoLicitacao"
                                @change="mudarLabelReferenteLicitacao($event)"
                                :disabled="!habilitaCampos"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2" v-if="!isTermoCadastramento">
                        <b-form-group>
                            <label for="numRef"
                                    class="required"
                                >Número {{ tipoLicitacaoSelecionado }}
                            </label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    id="numRef"
                                    placeholder="Digite o número"
                                    v-model="
                                        preContratoDto.numProcessoLicitacao
                                    "
                                    :disabled="!habilitaCampos"
                                    @input.native="
                                        $v.preContratoDto.numProcessoLicitacao.$touch()
                                    "
                                    :state="
                                        $v.preContratoDto.numProcessoLicitacao
                                            .$error
                                            ? false
                                            : null
                                    "
                                ></b-form-input>
                                <b-form-invalid-feedback
                                    >O número {{ tipoLicitacaoSelecionado }} é
                                    obrigatório</b-form-invalid-feedback
                                >
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label
                                v-show="mostraFormaAutorizacao"
                                for="formaAutorizacao"
                                class="required"
                                >Forma de Autorização</label
                            >
                            <b-form-select
                                class="mb-2 mr-sm-2 mb-sm-0"
                                :plain="true"
                                :options="formasAutorizacao"
                                v-model="preContratoDto.formaAutorizacao"
                                v-show="mostraFormaAutorizacao"
                                :disabled="!habilitaCampos"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group
                            :state="
                                $v.preContratoDto.dataAutorizacaoMapa.$error
                                    ? false
                                    : null
                            "
                            invalid-feedback="Data da autozização é obrigatória"
                        >
                            <label v-show="mostraFormaAutorizacao"
                                class="required"
                                >Data Autozização</label
                            >
                            <date-picker
                                v-model="preContratoDto.dataAutorizacaoMapa"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                                @input.native="
                                    $v.preContratoDto.dataAutorizacaoMapa.$touch()
                                "
                                v-show="mostraFormaAutorizacao"
                                :disabled="!habilitaCampos"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                    <!-- <b-col sm="12" md="2">
                        <b-form-group>
                            <label v-show="mostraNumeroMapa" for="numeroMapa"
                                >Número do Mapa</label
                            >
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    id="numeroMapa"
                                    placeholder="Digite o número do mapa"
                                    v-model="preContratoDto.numeroMapa"
                                    v-show="mostraNumeroMapa"
                                    :disabled="!habilitaCampos"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col> -->
                </b-row>
                <b-row>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <b-checkbox 
                                class="mt-2 mb-2 pt-2"
                                v-model="preContratoDto.renovacao" 
                            >
                                Renovação
                            </b-checkbox>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2" v-if="preContratoDto.renovacao">
                        <b-form-group>
                            <label for="tipoContratacao"
                                >Índice do Reajuste</label
                            >
                            <b-form-select
                                class="mb-2 mr-sm-2 mb-sm-0"
                                :plain="true"
                                value-field="indice"
                                text-field="indice"
                                :options="indicesReajuste"
                                v-model="preContratoDto.indiceReajuste"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2" v-if="preContratoDto.renovacao">
                        <b-form-group>
                            <label>Valor do Reajuste</label>
                            <money 
                                v-model="preContratoDto.valorReajuste"
                                v-bind="money"
                                class="form-control text-right mb-2 mr-sm-2 mb-sm-0"
                            ></money>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-form-group>
                            <label
                                class="required"
                            >Nome do Contrato</label>
                            <b-form-textarea
                                v-model="preContratoDto.vcObjetoContrato"
                                :rows="3"
                                @input="
                                    $v.preContratoDto.vcObjetoContrato.$touch()
                                "
                                :state="
                                    $v.preContratoDto.vcObjetoContrato.$error
                                        ? false
                                        : null
                                "
                                :disabled="!habilitaCampos"
                            ></b-form-textarea>
                            <b-form-invalid-feedback
                                >O nome do contrato é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label for="cpfcnpj"
                                class="required"
                            >CPF/CNPJ Formecedor</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    id="cpfcnpj"
                                    placeholder="Digite o CPF ou CNPJ do fornecedor"
                                    v-model="fornecedor.cnpjcpf"
                                    v-mask="[
                                        '###.###.###-##',
                                        '##.###.###/####-##'
                                    ]"
                                    @input="$v.fornecedor.cnpjcpf.$touch()"
                                    :state="
                                        $v.fornecedor.cnpjcpf.$error
                                            ? false
                                            : null
                                    "
                                    :disabled="!habilitaCampos"
                                ></b-form-input>
                                <b-input-group-append>
                                    <b-button
                                        variant="primary"
                                        @click="pesquisarFornecedor()"
                                        title="Clique para pesquisar o fornecedor"
                                        :disabled="!habilitaCampos"
                                    >
                                        <i class="fa fa-search"></i>
                                    </b-button>
                                </b-input-group-append>
                                <b-form-invalid-feedback
                                    >O CPF ou CNPJ do fornecedor é
                                    obrigatório</b-form-invalid-feedback
                                >
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="5">
                        <b-form-group>
                            <label for="razaoSocial"
                                class="required"
                            >Razão social</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    id="razaoSocial"
                                    v-model="fornecedor.razaoSocial"
                                    :disabled="true"
                                    @input="$v.fornecedor.razaoSocial.$touch()"
                                    :state="
                                        $v.fornecedor.razaoSocial.$error
                                            ? false
                                            : null
                                    "
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="12">
                        <label for="tblItensContrato"
                            class="required"
                        >Itens do contrato</label>
                        <app-tabela
                            idTabela="tblItensContrato"
                            :itens="preContratoDto.itensContrato"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                        >
                            <template slot="botoes">
                                <div class="d-flex flex-row-reverse mb-3">
                                    <btn-inserir-item-contrato
                                        v-on:salvarItemContrato="
                                            salvarItemContrato
                                        "
                                        :desativarBotao="!habilitaCampos||!camposVazios"
                                        v-if="permiteEditarExcluir"
                                    ></btn-inserir-item-contrato>
                                </div>
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <btn-editar-item-contrato
                                    :parentData="data"
                                    :desativarBotao="!habilitaCampos"
                                    v-on:editarItemContrato="
                                        atualizarItemContrato
                                    "
                                    v-if="permiteEditarExcluir"
                                ></btn-editar-item-contrato>
                                <span class="text-danger float-left mr-2" v-if="permiteEditarExcluir">
                                    <i
                                        class="fa fa-trash fa-lg icon-button"
                                        title="Excluir item contrato"
                                        @click.stop="
                                            confirmarRemocaoItemContrato(data)
                                        "
                                    ></i>
                                </span>
                                <btn-inserir-Subitem
                                    :parentData="data"
                                    :subItens="subItens"
                                    :situacaoContrato="preContratoDto.idSituacaoContrato"
                                    class="mr-2"
                                >
                                </btn-inserir-Subitem>
                                <btn-importar-SubItens
                                    :itemContrato="data"
                                    :desativarBotao="!habilitaCampos"
                                    v-on:subItens="quantidadeSubItens"
                                    v-if="permiteEditarExcluir"
                                >
                                </btn-importar-SubItens>
                            </template>
                            <template slot="valor" slot-scope="data">
                                <span class="text-nowrap">{{
                                    data.valorUnitario | currency
                                }}</span>
                            </template>
                        </app-tabela>
                    </b-col>
                </b-row>
            </div>
        </b-card-body>
        <b-card-footer>
            <b-button
                variant="primary"
                @click.stop="salvarForm()"
                :disabled="!habilitarSalvar || !habilitaCampos"
                class="mr-2"
                v-if="permiteEditarExcluir"
            >
                <i class="fa fa-save"></i>
                {{ textoBotao }}
            </b-button>
            <b-button variant="danger" @click.stop="cancelar()" class="mr-2">
                <span> <i class="fa fa-history mr-2"></i> Voltar </span>
            </b-button>
            <div class="float-right">
                <b-button
                    variant="success"
                    @click.stop="concluir()"
                    :disabled="!habilitarSalvar || !habilitaCampos"
                    v-if="$temAcessoView('CONT-PRE-02') && permiteEditarExcluir"
                >
                    <span> <i class="fa fa-check"></i> Concluir </span>
                </b-button>
            </div>
        </b-card-footer>
    </b-card>
</template>

<script>
import BtnInserirItemContrato from './BtnInserirItemContrato'
import BtnEditarItemContrato from './BtnEditarItemContrato'
import BtnInserirSubitem from './BtnInserirSubItem'
import BtnImportarSubItens from './BtnImportarSubItens'
import { required } from 'vuelidate/lib/validators'
import PreContratoServicos from './PreContratoServicos'
import { situacaoContrato } from '../SituacaoContrato'
import { formasAutorizacao } from '../FormasAutorizacao'
import { tiposContratacao } from '../TiposContratacao'
import { tiposLicitacao } from '../TiposLicitacao'

export default {
    components: {
        BtnInserirItemContrato,
        BtnEditarItemContrato,
        BtnInserirSubitem,
        BtnImportarSubItens
    },

    data() {
        return {
            erros: [],
            contrato: {},
            preContratoDto: {
                idContrato: '00000000-0000-0000-0000-000000000000',
                vcCodigoEstruturado: '',
                tpContratacao: 2,
                nuSaldoContrato: 0,
                nuValorGlobalContrato: 0,
                codTipoLicitacao: 1,
                dataAutorizacaoMapa: null,
                vcObjetoContrato: '',
                formaAutorizacao: 0,
                numeroMapa: '',
                codFornecedor: '',
                nomeFornecedor: '',
                vcProcessoAditivo: '',
                itensContrato: [],
                numProcessoLicitacao: null,
                renovacao: false,       
                indiceReajuste: null,
                valorReajuste: 0,
                idSituacaoContrato: situacaoContrato.PRE_CONTRATO_EM_ELABORACAO,
                usrLoginCadastro: this.$store.getters.usuario.login
            },
            operacao: 'INSERIR',
            textoBotao: 'Salvar',
            tiposContratacao: tiposContratacao,
            tiposLicitacao: tiposLicitacao,
            tipoLicitacao: 1,
            tipoLicitacaoSelecionado: 'Pregão',
            formasAutorizacao: formasAutorizacao,
            mostraFormaAutorizacao: false,
            edicaoPreContrato: false,
            numeroProcesso: 1,
            numeroMapa: '',
            fornecedor: {
                cnpjcpf: '',
                razaoSocial: ''
            },
            cnpjcpfFornecedor: '',
            mostraNumeroMapa: false,
            mostraPesquisaAtaESelecaoDeProcesso: true,
            campos: [
                {
                    key: 'descricao',
                    label: 'Descrição',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'descricaoResumida',
                    label: 'Descrição resumida',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-right' 
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5,
            selecionado: [],
            habilitaCampos: true,
            subItens: [],
            preContratoSalvo: false,
            indicesReajuste: [],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            }
        }
    },

    methods: {
        obterContrato() {
            this.$store.dispatch('addRequest')
            PreContratoServicos.obterPorId(this.$route.params.contratoId).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.contrato = response.data
                            this.converterContratoParaPrecontrato(this.contrato)
                            if (
                                this.preContratoDto.idSituacaoContrato ==
                                situacaoContrato.PRE_CONTRATO_CONCLUIDO
                            ) {
                                this.habilitaCampos = false
                                this.mudarTextoOperacao()
                            }
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        converterContratoParaPrecontrato(contrato) {
            this.preContratoDto.idContrato = contrato.idContrato
            this.preContratoDto.vcCodigoEstruturado =
                contrato.vcCodigoEstruturado

            this.preContratoDto.tpContratacao = contrato.tpContratacao

            if (this.preContratoDto.tpContratacao != 2) {
                this.selecionaTipoContratacao(this.preContratoDto.tpContratacao)

                this.preContratoDto.dataAutorizacaoMapa = this.$moment(
                    contrato.dataAutorizacaoMapa
                )
                this.preContratoDto.formaAutorizacao = contrato.formaAutorizacao
                this.preContratoDto.vcProcessoAditivo =
                    contrato.vcProcessoAditivo
            }

            this.preContratoDto.codTipoLicitacao = contrato.codTipoLicitacao
            this.preContratoDto.vcObjetoContrato = contrato.vcObjetoContrato
            this.preContratoDto.codFornecedor = contrato.codFornecedor
            this.preContratoDto.nomeFornecedor = contrato.nomeFornecedor
            this.fornecedor.cnpjcpf = contrato.fornecedor.cnpj
            this.fornecedor.razaoSocial = contrato.fornecedor.nome
            this.preContratoDto.itensContrato = contrato.itensContrato
            this.preContratoDto.idSituacaoContrato = contrato.idSituacaoContrato
            this.preContratoDto.numProcessoLicitacao =
                contrato.numProcessoLicitacao

            this.edicaoPreContrato = true
        },

        pesquisarFornecedor() {
            if (
                this.fornecedor.cnpjcpf.length == 14 ||
                this.fornecedor.cnpjcpf.length == 18
            ) {
                let cpfcnpjSemCaracteresEspeciais =
                    this.fornecedor.cnpjcpf.replace(/\D+/g, '')
                this.$store.dispatch('addRequest')
                PreContratoServicos.obterFornecedor(
                    cpfcnpjSemCaracteresEspeciais
                ).then((response) => {
                    if (response) {
                        if (response.success && response.data != null) {
                            this.erros = []
                            this.fornecedor.razaoSocial = response.data.nome
                            this.preContratoDto.codFornecedor = response.data.codFornecedor
                            this.preContratoDto.nomeFornecedor = response.data.nome
                        } else {
                            this.erros.push('Fornecedor não encontrado')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        salvarItemContrato(item) {
            
            if (this.preContratoDto.idContrato == '00000000-0000-0000-0000-000000000000') {
                this.preContratoDto.itensContrato.push(item)
                if (!this.$v.$invalid) {
                    this.salvarForm()
                }else{
                    this.preContratoDto.itensContrato = []
                }
            } else {
                this.inserirItemContrato(item)
            }
        },

        obterItensContrato() {
            if (this.preContratoDto.idContrato != 0) {
                PreContratoServicos.obterItensContrato(
                    this.preContratoDto.idContrato
                ).then((response) => {
                    if (response) {
                        if (response.success) {
                            this.preContratoDto.itensContrato = response.data
                        }
                    }
                })
            }
        },

        confirmarRemocaoItemContrato(item) {
            if (this.habilitaCampos) {
                this.$swal({
                    title: 'Excluir item contrato',
                    html: `Confirma a exclusão do item do contrato?
                <br/><br/><div class="alert alert-danger" role="alert">
                        Atenção! Essa é uma operação irreversível!
                    </div>`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                }).then((result) => {
                    if (result.value) {
                        this.removerItemContrato(item)
                    }
                })
            }
        },

        removerItemContrato(item) {
            this.$store.dispatch('addRequest')
            PreContratoServicos.removerItemContrato(
                item.idContrato,
                item.itemContratoId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.preContratoDto.itensContrato = response.data
                        this.$toast.success(
                            'Item contrato removido com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                    } else {
                        this.$toast.error(response.errors, 'ERROR', this.error)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        inserirItemContrato(itemContato) {
            itemContato.idContrato = this.preContratoDto.idContrato
            this.$store.dispatch('addRequest')
            PreContratoServicos.inserirItemContrato(itemContato).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.preContratoDto.itensContrato = response.data

                            this.$toast.success(
                                'Item adicionado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.preContratoSalvo = true
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        atualizarItemContrato(itemContato) {
            itemContato.idContrato = this.preContratoDto.idContrato
            this.$store.dispatch('addRequest')
            PreContratoServicos.atualizarItemContrato(itemContato).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.preContratoDto.itensContrato = response.data

                            this.$toast.success(
                                'Sub item atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        quantidadeSubItens() {
            this.preContratoDto.itensContrato = []
            this.obterItensContrato()
        },

        calculaValoresItemContrato() {
            let valor = this.preContratoDto.itensContrato.reduce(
                (soma, item) => soma + item.valorUnitario,
                0
            )
            this.preContratoDto.nuSaldoContrato = valor
            this.preContratoDto.nuValorGlobalContrato = valor
        },

        selecionaTipoContratacao(value) {
            if (value == 1 || value == 3 || value == 4 || value == 5) {
                this.mostraFormaAutorizacao = true
                this.mostraNumeroMapa = false
                this.mostraPesquisaAtaESelecaoDeProcesso = false
                this.numeroMapa = ''
                this.preContratoDto.vcProcessoAditivo = ''
                if (value == 3) {
                    this.mostraNumeroMapa = true
                }
                if (value == 5) {
                    this.preContratoDto.numProcessoLicitacao =
                        'TERMO CADASTRAMENTO'
                }
                // tipo contratacao = contrato
            } else { 
                this.mostraFormaAutorizacao = false
                this.mostraNumeroMapa = false
                this.preContratoDto.dataAutorizacaoMapa = null
                this.mostraPesquisaAtaESelecaoDeProcesso = true
                this.preContratoDto.vcProcessoAditivo = ''
            }
            this.formaAutorizacao = 0
        },

        mudarLabelReferenteLicitacao(value) {
            this.tipoLicitacaoSelecionado = this.tiposLicitacao.find(
                (x) => x.value == value
            ).text
        },

        salvarForm() {
            this.calculaValoresItemContrato()
            if (this.preContratoDto.dataAutorizacaoMapa != null) {
                this.preContratoDto.dataAutorizacaoMapa = this.$moment(
                    this.preContratoDto.dataAutorizacaoMapa,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }

            if (this.preContratoDto.tpContratacao == 5) {
                this.preContratoDto.codTipoLicitacao = 8
            }

            if (!this.preContratoDto.renovacao) {
                this.preContratoDto.indiceReajuste = null
                this.preContratoDto.valorReajuste = null
            }

            if (this.preContratoDto.idContrato != '00000000-0000-0000-0000-000000000000') {
                this.$store.dispatch('addRequest')
                PreContratoServicos.atualizarPreContrato(
                    this.preContratoDto
                ).then((response) => {
                    if (response) {
                        if (response.success) {
                            if (
                                this.preContratoDto.idSituacaoContrato ==
                                situacaoContrato.PRE_CONTRATO_EM_ELABORACAO
                            ) {
                                if (
                                    this.preContratoDto.dataAutorizacaoMapa !=
                                    null
                                ) {
                                    this.preContratoDto.dataAutorizacaoMapa =
                                        this.$moment(
                                            this.preContratoDto
                                                .dataAutorizacaoMapa
                                        ).format('DD/MM/YYYY')
                                }
                                this.$toast.success(
                                    'Pré contrato atualizado com sucesso!',
                                    'OK',
                                    this.$toastConfig.success
                                )
                            } else {
                                this.$toast.success(
                                    'Pré contrato concluído!',
                                    'OK',
                                    this.$toastConfig.success
                                )
                                this.mudarTextoOperacao()
                            }
                            this.preContratoSalvo = true
                        } else {
                            this.erros = response.errors
                            if (
                                this.preContratoDto.dataAutorizacaoMapa != null
                            ) {
                                this.preContratoDto.dataAutorizacaoMapa =
                                    this.$moment(
                                        this.preContratoDto.dataAutorizacaoMapa,
                                        'YYYY-MM-DD'
                                    ).format('DD/MM/YYYY')
                            }
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            } else {
                this.$store.dispatch('addRequest')
                
                if (!this.preContratoDto.renovacao) {
                    this.preContratoDto.indiceReajuste = null
                    this.preContratoDto.valorReajuste = null
                }
                
                PreContratoServicos.inserirPreContrato(
                    this.preContratoDto
                ).then((response) => {
                    if (response) {
                        if (response.success) {
                            this.preContratoDto.itensContrato =
                                response.data.itensContrato
                            this.preContratoDto.idContrato =
                                response.data.idContrato

                            if (
                                this.preContratoDto.idSituacaoContrato ==
                                situacaoContrato.PRE_CONTRATO_EM_ELABORACAO
                            ) {
                                if (
                                    this.preContratoDto.dataAutorizacaoMapa !=
                                    null
                                ) {
                                    this.preContratoDto.dataAutorizacaoMapa =
                                        this.$moment(
                                            this.preContratoDto
                                                .dataAutorizacaoMapa
                                        ).format('DD/MM/YYYY')
                                }
                                this.$toast.success(
                                    'Pré contrato salvo com sucesso!',
                                    'OK',
                                    this.$toastConfig.success
                                )
                                this.habilitaCampos = true
                            } else {
                                this.$toast.success(
                                    'Pré contrato concluído!',
                                    'OK',
                                    this.$toastConfig.success
                                )
                                this.mudarTextoOperacao()
                            }
                            this.preContratoSalvo = true
                            this.erros = []
                        } else {
                            this.habilitaCampos = true
                            this.erros = response.errors
                            this.preContratoDto.idSituacaoContrato = 3
                            if (
                                this.preContratoDto.dataAutorizacaoMapa != null
                            ) {
                                this.preContratoDto.dataAutorizacaoMapa =
                                    this.$moment(
                                        this.preContratoDto.dataAutorizacaoMapa,
                                        'YYYY-MM-DD'
                                    ).format('DD/MM/YYYY')
                            }
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        mudarTextoOperacao() {
            if (this.$route.params.contratoId) {
                this.operacao = 'EDIÇÃO'
            }

            if (
                this.preContratoDto.idSituacaoContrato ==
                situacaoContrato.PRE_CONTRATO_CONCLUIDO
            ) {
                this.operacao = 'CONCLUÍDO'
            }
        },

        cancelar() {
            this.erros = []
            if (this.preContratoSalvo) {
                this.$store.dispatch('setRecarregar', true)
            }
            this.$router.push({ name: 'Contratos' })
        },

        concluir() {
            this.preContratoDto.idSituacaoContrato =
                situacaoContrato.PRE_CONTRATO_CONCLUIDO
            this.salvarForm()
            this.habilitaCampos = false
        },

        tipoContratacaoEscolhida() {
            if (this.preContratoDto.tpContratacao == 2) {
                return true
            } else if (
                this.preContratoDto.tpContratacao != 2 &&
                this.preContratoDto.dataAutorizacaoMapa != null &&
                this.preContratoDto.formaAutorizacao != 0
            ) {
                return true
            }
            return false
        },

        validaTamanhoCpfCnpj() {
            return (
                this.fornecedor.cnpjcpf.length == '14' ||
                this.fornecedor.cnpjcpf.length == '18'
            )
        },

        obterListagens() {
            this.$store.dispatch('addRequest')
            PreContratoServicos.obterListagens().then(response => {
                if (response) {
                    if (response.success) {
                        this.indicesReajuste = response.data.indicesReajuste
                    } else {
                        this.$toast.error(
                            'Não foi possivel obter os dados listaveis do pré-contrato',
                            'Error',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        this.obterListagens()
        if (this.$route.params.contratoId) {
            this.mudarTextoOperacao()
            this.textoBotao = 'Atualizar'

            this.obterContrato()
        }
    },

    computed: {
        habilitarSalvar() {
            return !this.$v.$invalid
        },

        isTermoCadastramento() {
            return this.preContratoDto.tpContratacao == 5
        },

        permiteEditarExcluir() {
            return this.preContratoDto.idSituacaoContrato != situacaoContrato.PRE_CONTRATO_CONCLUIDO
        },
        camposVazios() {
            return (this.preContratoDto.vcCodigoEstruturado != '' && 
                (this.preContratoDto.numProcessoLicitacao != null && this.preContratoDto.numProcessoLicitacao != '') &&
                this.preContratoDto.vcObjetoContrato != '' &&
                this.preContratoDto.codFornecedor != '' &&
                this.tipoContratacaoEscolhida())
        }
    },

    validations: {
        preContratoDto: {
            dataAutorizacaoMapa: {
                tipoContratacao() {
                    return this.tipoContratacaoEscolhida()
                }
            },
            vcObjetoContrato: {
                required
            },
            numProcessoLicitacao: {
                required
            },
            itensContrato: {
                validarItemContrato() {
                    if (this.preContratoDto.idContrato == '00000000-0000-0000-0000-000000000000') {
                        if (this.preContratoDto.itensContrato.length > 0) {
                            return true
                        }
                        return false
                    }
                    return true
                }
            }
        },
        fornecedor: {
            cnpjcpf: {
                required,
                validaCpfCnpj() {
                    return this.validaTamanhoCpfCnpj()
                }
            },
            razaoSocial: {
                required
            }
        }
        
    }
}
</script>
